module.exports = __webpack_public_path__ + "static/media/pep-coding.6488df26.png";